export default "__VITE_ASSET__C3XYgT99__"